import React from "react";
import PropTypes from "prop-types";
import { Dispatcher, NavigatorAction, BookUtils } from "../../../flux";
import Header from "../header";
import BookReader from "../book-reader/book-reader";

export default class Reading extends React.Component {
  constructor(props) {
    super(props);
    const state = {
      showMenu: null,
      completeable: false,
      lastCFI: null, // Reading/Chrome scope
      bookCFI: null, // Main book scope
      loading: false // creating snippet
    };
    this.state = Object.assign(state, this.props.savedState);

    this._toggleMenu = this._toggleMenu.bind(this);
    this.startReading = this.startReading.bind(this);
  }

  componentWillUnmount() {
    this.props.book.viewer.Viewport.setAutofocus(true);
    Dispatcher.unbind(Dispatcher.BOOK_NEXT_PAGE, "reading-next-page");
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_READY, "next-page-available");
    this.exitSnippet();
  }

  componentDidMount() {
    this.props.book.viewer.Viewport.setAutofocus(false);
    this.startAssignment();
  }

  exitSnippet() {
    if (this.state.bookCFI) {
      this.props.book.viewer.Book.goToCFI(this.state.bookCFI, () => {
        this.props.book.viewer.Snippet.exit();
      });
    } else {
      this.props.book.viewer.Snippet.exit();
    }
  }

  startAssignment() {
    this.startReading(this.props.reading);
    Dispatcher.bind(
      Dispatcher.BOOK_SNIPPET_READY,
      () =>
        this.props.book.viewer.Snippet.hasNextPage(this.nextPage.bind(this)),
      "next-page-available"
    );
    Dispatcher.bind(
      Dispatcher.BOOK_NEXT_PAGE,
      () => {
        if (this.state.completeable) {
          this.props.markReadingAsComplete(this.props.reading.uuid);
          Dispatcher.bindOnce(Dispatcher.BOOK_PAGE_READY, () => {
            NavigatorAction.replace("reading-complete", {
              reading: this.props.reading
            });
          });
        }
      },
      "reading-next-page"
    );
  }

  nextPage(response) {
    this.setState({ completeable: !response.data });
  }

  enterSnippet(range, cfi) {
    const callback = () => {
      this.props.book.viewer.Book.goToCFI(cfi);
      this.setState({ loading: false });
    };
    this.setState({ isReadingComplete: false, lastCFI: null, loading: true });
    this.props.book.viewer.Snippet.enter(range, callback.bind(this));
  }

  getStartEnd(reading) {
    if (this._pageLabel(reading)) {
      return {
        start: BookUtils.getCFIForPageLabel(this.props.isbn, reading.start),
        end: BookUtils.getCFIForPageLabel(this.props.isbn, reading.end),
        exclusive: reading.exclusive
      };
    } else if (this._pageIndex(reading)) {
      return {
        start: BookUtils.isCFI(reading.start)
          ? reading.start
          : BookUtils.getCFIFromIndex(
              this.props.isbn,
              parseInt(reading.start, 10)
            ),
        end: BookUtils.isCFI(reading.end)
          ? "/" + (parseInt(reading.end.substring(1), 10) + 1)
          : BookUtils.getCFIFromIndex(
              this.props.isbn,
              parseInt(reading.end, 10) + 1
            ),
        exclusive: false
      };
    }
    return {
      start: reading.start,
      end: reading.end,
      exclusive: reading.exclusive
    };
  }

  _pageLabel(reading) {
    return (
      reading.range_type === "page_label" ||
      (!reading.range_type && reading.metadata.tooling === "page-range")
    );
  }

  _pageIndex(reading) {
    return reading.range_type === "page_index";
  }

  startReading(reading) {
    let cfi = this.state.lastCFI;
    const startEnd = this.getStartEnd(reading);
    if (!cfi) {
      if (this._pageLabel(reading)) {
        cfi = startEnd.start;
      } else if (this._pageIndex(reading)) {
        cfi = BookUtils.isCFI(reading.start)
          ? reading.start
          : BookUtils.getCFIFromIndex(this.props.isbn, reading.start);
      } else {
        cfi = reading.start;
      }
    }
    this.enterSnippet(startEnd, cfi);
  }

  _minimize(readerState, callback) {
    const lastCFI = `${this.props.book.pageCFI}!${this.props.book.lastCFI}`;
    this.setState({ lastCFI }, () => {
      const newState = {
        route: "assignment-reading",
        currentReading: this.props.reading
      };
      newState[this.props.route] = Object.assign({}, this.state, {
        "book-reader": readerState
      });
      this.props.minimize(newState, callback);
    });
  }

  _toggleMenu() {
    this.setState({
      showMenu: !this.state.showMenu
    });
  }

  _menuStatus(open) {
    return open ? "menu-open" : "menu-close";
  }

  render() {
    const reading = this.props.reading;
    return (
      <div id="reading">
        <div
          className={`chrome-content ${this._menuStatus(this.state.showMenu)}`}
        >
          <Header
            book={this.props.book}
            assignment={this.props.assignment}
            reading={reading}
            readings={this.props.readings}
            loading={this.state.loading}
            startReading={this.startReading}
            title={
              (reading && reading.description) || i18n.t("assignments.untitled")
            }
            menu={this._toggleMenu}
            menuOpen={this.state.showMenu}
            menuStatus={this._menuStatus}
            minimize={this._minimize.bind(this)}
            close={this.props.close}
            focus={true}
          />
          <BookReader
            className="chrome-full"
            book={this.props.book}
            reading={reading}
            hasRightButtons={true}
            minimize={this._minimize.bind(this)}
            startCFI={reading.start}
            endCFI={reading.end}
            exclusive={reading.exclusive}
            savedState={this.props.savedState["book-reader"]}
            assignment={this.props.assignment}
          >
            {this.props.children}
          </BookReader>
        </div>
      </div>
    );
  }
}

Reading.propTypes = {
  isbn: PropTypes.string.isRequired,
  book: PropTypes.object.isRequired,
  reading: PropTypes.object,
  assignmentId: PropTypes.string,
  readings: PropTypes.array,
  pagelist: PropTypes.array,
  assignment: PropTypes.object,
  markReadingAsComplete: PropTypes.func
};

Reading.defaultProps = {
  savedState: {}
};
